import React from 'react';
import { HomeButton } from "../components/HomeButton"

export const HomePage: React.FC<{}> = () => {
  return (
    <div className="App">
      <HomeButton/>
      <header className='App-header'>
        <h1>True Searcher</h1>
          <p>Find the things ChatGPT & Google <u>can't</u></p>
          <div>
            <button onClick={() => (document.location.href = '#/signup')}>
              Sign up for our beta
            </button>
          </div>
          <div style={{paddingTop: '16px'}}>
            <a href="#/about" style={{color: 'white'}}>Learn More</a>
          </div>
        </header>
    </div>
  );
};